import { RawDataPoint } from './types';
import { CalculationMode } from './types';

export function generateRegressionData(
  swArr: (number | null)[],
  kArr: (number | null)[],
  swi: number,
  sor: number,
  mode: CalculationMode = 'decreasing',
  swi_fixed: number = 0
): RawDataPoint[] {
  
  const denominator = 1 - swi - sor - swi_fixed;

  if (Math.abs(denominator) < 1e-9) {
    throw new Error('Invalid parameters result in zero denominator.');
  }

  const data: RawDataPoint[] = [];
  const len = Math.min(swArr.length, kArr.length);

  for (let i = 0; i < len; i++) {
    const sw = swArr[i];
    const kVal = kArr[i];

    if (sw != null && kVal != null) {
      let saturationNormalized = 0;

      if (mode === 'decreasing') {
        saturationNormalized = (1 - sw - sor) / denominator;
      } else {
        saturationNormalized = (sw - swi) / denominator;
      }

      if (saturationNormalized > 0.0001 && kVal > 0.0001) {
        data.push({ key: i, so: saturationNormalized, kro: kVal });
      }
    }
  }

  return data;
}